<template>
  <div class="min-h-screen bg-gray-50 p-2">
    <div class="mx-auto">
      <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
        <h1 class="text-xl font-bold mb-6">廣告投放排程列表</h1>

        <!-- 搜索條件區域 -->
        <a-form layout="vertical" :model="searchForm" class="mb-6">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <!-- 關鍵字搜尋 -->
            <a-form-item label="檔期名稱關鍵字搜尋">
              <!-- <a-input v-model="searchForm.search" placeholder="輸入檔期名稱" allowClear @change="handleSearch" /> -->
              <a-input
                v-model="searchForm.search"
                placeholder="輸入檔期名稱"
                allowClear
              />
            </a-form-item>

            <!-- 版位選擇 -->
            <a-form-item label="廣告版位">
              <!-- <a-select v-model="searchForm.slot_id" placeholder="選擇廣告版位" allowClear @change="handleSearch"> -->
              <a-select
                v-model="searchForm.slot_id"
                placeholder="選擇廣告版位"
                allowClear
              >
                <a-select-option
                  v-for="slot in slotOptions"
                  :key="slot.id"
                  :value="slot.id"
                >
                  {{ slot.slot_name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <!-- 機台群組選擇 -->
            <a-form-item label="機台群組">
              <!-- <a-select v-model="searchForm.group_id" placeholder="選擇機台群組" allowClear @change="handleSearch"> -->
              <a-select
                v-model="searchForm.group_id"
                placeholder="選擇機台群組"
                allowClear
              >
                <a-select-option
                  v-for="group in groupOptions"
                  :key="group.id"
                  :value="group.id"
                >
                  {{ group.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <!-- 廣告類型 -->
            <a-form-item label="廣告類型">
              <!-- <a-select v-model="searchForm.ad_type" placeholder="選擇廣告類型" allowClear @change="handleSearch"> -->
              <a-select
                v-model="searchForm.ad_type"
                placeholder="選擇廣告類型"
                allowClear
              >
                <a-select-option value="image">圖片廣告</a-select-option>
                <a-select-option value="interactive_qa"
                  >問答廣告</a-select-option
                >
              </a-select>
            </a-form-item>

            <!-- 日期時間範圍 -->
            <a-form-item label="投放日期時間範圍">
              <a-range-picker
                v-model="dateRange"
                :show-time="{
                  format: 'HH:mm:ss',
                  defaultValue: [
                    moment('00:00:00', 'HH:mm:ss'),
                    moment('23:59:59', 'HH:mm:ss'),
                  ],
                }"
                format="YYYY-MM-DD HH:mm:ss"
                style="width: 100%"
                @change="onDateChange"
                :placeholder="['開始日期時間', '結束日期時間']"
              />
            </a-form-item>

            <!-- 活動狀態 -->
            <a-form-item label="活動狀態">
              <!-- <a-select v-model="searchForm.is_active" placeholder="選擇活動狀態" allowClear @change="handleSearch"> -->
              <a-select
                v-model="searchForm.is_active"
                placeholder="選擇活動狀態"
                allowClear
              >
                <a-select-option value="true">進行中</a-select-option>
                <a-select-option value="false">已結束</a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <!-- 搜索按鈕 -->
          <div class="flex justify-end space-x-4">
            <a-button @click="resetSearch">
              <a-icon type="undo" /> 重置
            </a-button>
            <a-button type="primary" @click="handleSearch">
              <a-icon type="search" /> 搜尋
            </a-button>
          </div>
        </a-form>
      </div>

      <!-- 表格區域 -->
      <div class="bg-white rounded-lg shadow-sm p-6">
        <a-table
          :columns="columns"
          :data-source="campaignList"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.campaign_id"
          @change="handleTableChange"
          bordered
        >
          <!-- 廣告類型 -->
          <template slot="adType" slot-scope="text">
            <a-tag :color="text === 'image' ? 'blue' : 'purple'">
              {{ text === "image" ? "圖片廣告" : "問答廣告" }}
            </a-tag>
          </template>

          <!-- 活動狀態 -->
          <template slot="status" slot-scope="text">
            <a-badge :status="text ? 'success' : 'default'" />
            <span>{{ text ? "進行中" : "已結束" }}</span>
          </template>

          <!-- 機台數量 -->
          <template slot="machineCount" slot-scope="text">
            <a-badge
              :count="text"
              :overflow-count="99999"
              :number-style="{ backgroundColor: '#52c41a' }"
            />
          </template>

          <!-- 顯示時段 -->
          <template slot="timeRange" slot-scope="text, record">
            {{ record.start_time }} - {{ record.end_time }}
          </template>

          <!-- 操作按鈕 -->
          <template slot="action" slot-scope="text, record">
            <div class="flex justify-around w-full">
              <!-- <div @click="checkIfScheduleActive(record)">aaaaaaaaaaaa</div> -->
              <a-tooltip
                :title="!record.is_active ? '已結束的排程無法編輯' : ''"
              >
                <a-button
                  type="primary"
                  size="small"
                  @click="handleEdit(record)"
                  :disabled="!record.is_active"
                >
                  <a-icon type="edit" /> 編輯
                </a-button>
              </a-tooltip>
              <!-- <a-popconfirm title="確定要刪除此廣告排程嗎？" ok-text="確定" cancel-text="取消" @confirm="handleDelete(record.campaign_id)" placement="topRight"> -->
              <a-popconfirm
                title="確定要刪除此廣告排程嗎？"
                ok-text="確定"
                cancel-text="取消"
                @confirm="handleDelete(record)"
                placement="topRight"
              >
                <template slot="icon">
                  <a-icon type="question-circle" style="color: red" />
                </template>
                <template slot="title">
                  <div>
                    <p>確定要刪除「{{ record.campaign_name }}」嗎？</p>
                    <p class="text-xs text-gray-500">
                      此操作不可恢復，如果此廣告內容未被其他排程使用，將一併刪除。
                    </p>
                  </div>
                </template>
                <a-button type="danger" size="small">
                  <a-icon type="delete" /> 刪除
                </a-button>
              </a-popconfirm>
            </div>
          </template>
        </a-table>

        <!-- 分頁 -->
        <div class="mt-4 flex justify-end">
          <a-pagination
            v-model="pagination.current"
            :total="pagination.total"
            :page-size.sync="pagination.pageSize"
            :show-size-changer="true"
            :page-size-options="['10', '20', '50', '100']"
            :show-total="(total) => `共 ${total} 筆資料`"
            @change="handlePageChange"
            @showSizeChange="handleSizeChange"
          />
        </div>
      </div>

      <!-- 編輯廣告排程模態窗 -->
      <a-modal
        title="編輯廣告排程"
        :visible="editModalVisible"
        :confirm-loading="editLoading"
        @ok="handleEditSubmit"
        @cancel="closeEditModal"
        width="700px"
      >
        <a-form :form="editForm" layout="vertical">
          <!-- 檔期名稱 -->
          <a-form-item label="檔期名稱" :required="true">
            <a-input
              v-decorator="[
                'campaign_name',
                {
                  rules: [{ required: true, message: '請輸入檔期名稱' }],
                  initialValue: currentRecord.campaign_name,
                },
              ]"
              placeholder="請輸入檔期名稱"
            />
          </a-form-item>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- 廣告版位選擇 -->
            <a-form-item label="廣告版位" :required="true">
              <a-select
                v-decorator="[
                  'slot_id',
                  {
                    rules: [{ required: true, message: '請選擇廣告版位' }],
                    initialValue: currentRecord.slot_id,
                  },
                ]"
                placeholder="請選擇廣告版位"
              >
                <a-select-option
                  v-for="slot in slotOptions"
                  :key="slot.id"
                  :value="slot.id"
                >
                  {{ slot.slot_name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <!-- 機台群組選擇 -->
            <a-form-item label="機台群組" :required="true">
              <a-select
                v-decorator="[
                  'group_id',
                  {
                    rules: [{ required: true, message: '請選擇機台群組' }],
                    initialValue: currentRecord.group_id,
                  },
                ]"
                placeholder="請選擇機台群組"
              >
                <a-select-option
                  v-for="group in groupOptions"
                  :key="group.id"
                  :value="group.id"
                >
                  {{ group.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- 優先級別 -->
            <a-form-item label="優先級別" :required="true">
              <div class="text-xs text-gray-500 mb-1">
                優先級越高，同時段衝突時優先顯示（5最高，1最低）
              </div>
              <a-select
                v-decorator="[
                  'priority',
                  {
                    initialValue: currentRecord.priority || 3,
                    rules: [{ required: true, message: '請設定優先級別' }],
                  },
                ]"
                size="large"
                style="width: 100%"
              >
                <a-select-option :value="5">非常高 (5)</a-select-option>
                <a-select-option :value="4">高 (4)</a-select-option>
                <a-select-option :value="3">中 (3)</a-select-option>
                <a-select-option :value="2">低 (2)</a-select-option>
                <a-select-option :value="1">非常低 (1)</a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- 開始日期 -->
            <a-form-item label="開始日期時間" :required="true">
              <a-date-picker
                v-decorator="[
                  'start_datetime',
                  {
                    rules: [{ required: true, message: '請選擇開始日期時間' }],
                    initialValue: currentRecord.start_datetime
                      ? moment.utc(currentRecord.start_datetime).local()
                      : null,
                  },
                ]"
                style="width: 100%"
                :show-time="{
                  format: 'HH:mm:ss',
                  defaultValue: moment('00:00:00', 'HH:mm:ss'),
                }"
                format="YYYY-MM-DD HH:mm:ss"
              />
            </a-form-item>

            <!-- 結束日期 -->
            <a-form-item label="結束日期時間" :required="true">
              <a-date-picker
                v-decorator="[
                  'end_datetime',
                  {
                    rules: [{ required: true, message: '請選擇結束日期時間' }],
                    initialValue: currentRecord.end_datetime
                      ? moment.utc(currentRecord.end_datetime).local()
                      : null,
                  },
                ]"
                style="width: 100%"
                :show-time="{
                  format: 'HH:mm:ss',
                  defaultValue: moment('23:59:59', 'HH:mm:ss'),
                }"
                format="YYYY-MM-DD HH:mm:ss"
                :disabled-date="disabledDate"
              />
            </a-form-item>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- 開始時間 -->
            <a-form-item label="每日開始時間" :required="true">
              <a-time-picker
                v-decorator="[
                  'start_time',
                  {
                    rules: [{ required: true, message: '請選擇開始時間' }],
                    initialValue: currentRecord.start_time
                      ? moment(currentRecord.start_time, 'HH:mm:ss')
                      : null,
                  },
                ]"
                style="width: 100%"
                format="HH:mm:ss"
              />
            </a-form-item>

            <!-- 結束時間 -->
            <a-form-item label="每日結束時間" :required="true">
              <a-time-picker
                v-decorator="[
                  'end_time',
                  {
                    rules: [{ required: true, message: '請選擇結束時間' }],
                    initialValue: currentRecord.end_time
                      ? moment(currentRecord.end_time, 'HH:mm:ss')
                      : null,
                  },
                ]"
                style="width: 100%"
                format="HH:mm:ss"
              />
            </a-form-item>
          </div>

          <div class="bg-gray-50 p-4 rounded-md mt-4">
            <div class="flex items-center mb-2">
              <a-icon type="info-circle" class="text-blue-500 mr-2" />
              <span class="font-medium">編輯提示</span>
            </div>
            <ul class="text-sm text-gray-600 space-y-1 ml-6 list-disc">
              <li>修改投放時段可能會影響廣告的顯示效果</li>
              <li>結束日期必須晚於或等於開始日期</li>
              <li>
                當廣告版位或機台群組變更時，請確認是否會與其他檔期發生衝突
              </li>
            </ul>
          </div>

          <!-- 🆕 廣告圖片編輯區塊 (僅圖片廣告顯示) -->
          <div
            v-if="currentRecord.ad_type === 'image'"
            class="bg-purple-50 p-4 rounded-lg border border-purple-200 mt-4"
          >
            <div class="flex items-center mb-4">
              <a-icon type="picture" class="text-purple-600 mr-2" />
              <span class="font-medium text-purple-800">廣告圖片內容</span>
              <a-tag color="blue" class="ml-2">圖片廣告</a-tag>
            </div>

            <!-- 當前圖片顯示區 (可拖曳調整順序) -->
            <div
              v-if="currentImages.length > 0 && newImageList.length === 0"
              class="mb-4"
            >
              <label class="block text-sm font-medium text-gray-700 mb-2">
                目前使用的廣告圖片
                <span class="text-gray-500 text-xs">(可拖曳調整輪播順序)</span>
              </label>
              <!-- 🆕 使用 draggable 讓現有圖片可拖曳 -->
              <draggable
                v-model="currentImages"
                class="flex flex-wrap gap-2"
                animation="200"
              >
                <div
                  v-for="(imageName, index) in currentImages"
                  :key="imageName"
                  class="relative w-[104px] h-[104px] border border-gray-200 rounded p-1 flex items-center justify-center overflow-hidden bg-white hover:border-blue-400 transition-colors cursor-move"
                >
                  <img
                    :src="getImageUrl(currentRecord.campaign_id, imageName)"
                    :alt="`廣告圖片 ${index + 1}`"
                    class="max-w-full max-h-full object-contain cursor-pointer"
                    @click="
                      showImagePreview(
                        getImageUrl(currentRecord.campaign_id, imageName)
                      )
                    "
                    @error="handleImageError"
                  />
                  <div
                    class="absolute top-1 right-1 bg-blue-500 text-white text-xs px-1 rounded"
                  >
                    {{ index + 1 }}
                  </div>
                </div>
              </draggable>
              <!-- 順序變更提示 -->
              <div
                v-if="isImageOrderChanged"
                class="mt-2 text-sm text-orange-600"
              >
                <a-icon type="swap" class="mr-1" />
                圖片順序已變更，提交後將更新輪播順序
              </div>
            </div>

            <!-- 更換圖片區域 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                更換廣告圖片
                <span class="text-gray-500 text-xs"
                  >(可選，不選則保持原圖片)</span
                >
              </label>

              <div class="flex flex-wrap gap-2">
                <!-- 可拖曳的新圖片列表 -->
                <draggable
                  v-model="newImageList"
                  class="flex flex-wrap gap-2"
                  animation="200"
                >
                  <div
                    v-for="(file, index) in newImageList"
                    :key="file.uid || index"
                    class="relative group w-[104px] h-[104px] border border-gray-200 rounded p-1 flex items-center justify-center overflow-hidden hover:border-blue-500 transition-colors bg-white"
                  >
                    <img
                      :src="file.url || file.thumbUrl"
                      class="max-w-full max-h-full object-contain"
                    />
                    <!-- 操作遮罩 -->
                    <div
                      class="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-2"
                    >
                      <a-icon
                        type="eye"
                        class="text-white cursor-pointer hover:text-blue-400 text-lg"
                        @click="handlePreview(file)"
                      />
                      <a-icon
                        type="delete"
                        class="text-white cursor-pointer hover:text-red-400 text-lg"
                        @click="removeNewImage(file)"
                      />
                    </div>
                    <div
                      class="absolute top-1 right-1 bg-green-500 text-white text-xs px-1 rounded"
                    >
                      新{{ index + 1 }}
                    </div>
                  </div>
                </draggable>

                <!-- 上傳按鈕 -->
                <a-upload
                  v-if="newImageList.length < 10"
                  name="file"
                  list-type="picture-card"
                  :show-upload-list="false"
                  :multiple="true"
                  :before-upload="beforeImageUpload"
                  :customRequest="customUploadRequest"
                  @change="handleNewImageChange"
                  class="edit-uploader"
                >
                  <div
                    class="flex flex-col items-center justify-center text-gray-500"
                  >
                    <a-icon type="plus" />
                    <div class="ant-upload-text">選擇新圖片</div>
                  </div>
                </a-upload>
              </div>

              <!-- 狀態提示 -->
              <div
                v-if="newImageList.length > 0"
                class="mt-2 text-sm text-green-600"
              >
                <a-icon type="info-circle" class="mr-1" />
                已選擇
                {{ newImageList.length }} 張新圖片，提交後將完全替換原有圖片
              </div>

              <!-- 圖片規格說明 -->
              <div class="text-sm text-gray-500 bg-gray-100 p-3 rounded mt-3">
                <a-icon type="info-circle" class="mr-1" />
                圖片規格要求：
                <ul class="mt-1 ml-4 list-disc">
                  <li>檔案大小：不超過 4MB</li>
                  <li>檔案格式：JPG、PNG、GIF</li>
                  <li>建議尺寸：最小 100x100 像素</li>
                  <li>上傳數量：最多 10 張圖片</li>
                </ul>
                <span class="text-orange-600 block mt-2"
                  >⚠️ 注意：更換圖片將完全覆蓋原有圖片，此操作不可恢復</span
                >
              </div>
            </div>
          </div>

          <!-- 問答廣告編輯區塊 -->
          <div
            v-else-if="currentRecord.ad_type === 'interactive_qa'"
            class="bg-purple-50 p-4 rounded-lg border border-purple-200 mt-4"
          >
            <div class="flex items-center mb-4">
              <a-icon type="question-circle" class="text-purple-600 mr-2" />
              <span class="font-medium text-purple-800">問答廣告內容</span>
              <a-tag color="purple" class="ml-2">問答廣告</a-tag>
            </div>

            <!-- 題目選擇區域 -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                問答題目
                <span class="text-gray-500 text-xs">(可更換不同題目)</span>
              </label>
              <a-select
                v-model="selectedQuestionId"
                placeholder="請選擇問答題目"
                style="width: 100%"
                show-search
                option-filter-prop="children"
              >
                <a-select-option
                  v-for="question in questionBank"
                  :key="question.id"
                  :value="question.id"
                >
                  {{ question.title }}
                </a-select-option>
              </a-select>

              <!-- 題目預覽 -->
              <div
                v-if="selectedQuestion"
                class="bg-white p-3 rounded border mt-2"
              >
                <h4 class="font-medium mb-2 text-purple-700">
                  {{ selectedQuestion.title }}
                </h4>
                <p class="text-gray-700 mb-2 text-sm">
                  {{ selectedQuestion.question }}
                </p>
                <div class="space-y-1">
                  <div
                    v-for="(option, index) in selectedQuestion.options.options"
                    :key="index"
                    :class="[
                      'p-2 rounded border text-sm',
                      selectedQuestion.correct_answer === option
                        ? 'bg-green-100 border-green-300'
                        : 'bg-gray-50 border-gray-200',
                    ]"
                  >
                    {{ index + 1 }}. {{ option }}
                    <a-icon
                      v-if="selectedQuestion.correct_answer === option"
                      type="check-circle"
                      class="text-green-600 ml-2"
                    />
                  </div>
                </div>
              </div>

              <!-- 題目變更提示 -->
              <div
                v-if="
                  currentQuestionData &&
                  selectedQuestionId !== currentQuestionData.question_id
                "
                class="mt-2 text-sm text-orange-600"
              >
                <a-icon type="swap" class="mr-1" />
                已更換為新題目，提交後將更新
              </div>
            </div>

            <!-- 問答背景圖片編輯區域 -->
            <div class="border-t border-purple-200 pt-4">
              <label class="block text-sm font-medium text-gray-700 mb-3">
                問答背景圖片
                <span class="text-gray-500 text-xs">(可單獨更換每張圖片)</span>
              </label>

              <div class="grid grid-cols-3 gap-4">
                <!-- 三張圖片：未作答、答對、答錯 -->
                <div
                  v-for="(label, index) in qaImageLabels"
                  :key="index"
                  class="text-center"
                >
                  <div class="text-xs text-gray-600 mb-2 font-medium">
                    {{ label }}
                  </div>

                  <!-- 當前圖片顯示 (有新圖片時隱藏) -->
                  <div
                    v-if="
                      qaCurrentImages[index] &&
                      !qaNewImages[getQaImageKey(index)]
                    "
                    class="relative w-full h-32 border border-gray-200 rounded overflow-hidden bg-white group"
                  >
                    <img
                      :src="
                        getQaImageUrl(
                          currentRecord.campaign_id,
                          qaCurrentImages[index]
                        )
                      "
                      :alt="label"
                      class="w-full h-full object-contain cursor-pointer"
                      @click="
                        showImagePreview(
                          getQaImageUrl(
                            currentRecord.campaign_id,
                            qaCurrentImages[index]
                          )
                        )
                      "
                      @error="handleImageError"
                    />
                    <!-- 懸浮顯示替換按鈕 -->
                    <div
                      class="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
                    >
                      <a-upload
                        name="file"
                        :show-upload-list="false"
                        :before-upload="
                          (file) => beforeQaImageUpload(file, index)
                        "
                        :customRequest="customUploadRequest"
                      >
                        <a-button type="primary" size="small" ghost>
                          <a-icon type="upload" /> 更換
                        </a-button>
                      </a-upload>
                    </div>
                    <div
                      class="absolute bottom-1 left-1 bg-blue-500 text-white text-xs px-1 rounded"
                    >
                      目前
                    </div>
                  </div>

                  <!-- 新上傳的圖片預覽 -->
                  <div
                    v-else-if="qaNewImages[getQaImageKey(index)]"
                    class="relative w-full h-32 border-2 border-green-400 rounded overflow-hidden bg-white group"
                  >
                    <img
                      :src="qaNewImages[getQaImageKey(index)].url"
                      :alt="label"
                      class="w-full h-full object-contain cursor-pointer"
                      @click="
                        showImagePreview(qaNewImages[getQaImageKey(index)].url)
                      "
                    />
                    <!-- 移除新圖片按鈕 -->
                    <div
                      class="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-2"
                    >
                      <a-icon
                        type="eye"
                        class="text-white cursor-pointer hover:text-blue-400 text-lg"
                        @click.stop="
                          showImagePreview(
                            qaNewImages[getQaImageKey(index)].url
                          )
                        "
                      />
                      <a-icon
                        type="delete"
                        class="text-white cursor-pointer hover:text-red-400 text-lg"
                        @click.stop="removeQaNewImage(index)"
                      />
                    </div>
                    <div
                      class="absolute bottom-1 left-1 bg-green-500 text-white text-xs px-1 rounded"
                    >
                      新
                    </div>
                  </div>

                  <!-- 無圖片時顯示上傳區域 -->
                  <div
                    v-else
                    class="w-full h-32 border-2 border-dashed border-gray-300 rounded flex items-center justify-center bg-gray-50"
                  >
                    <a-upload
                      name="file"
                      :show-upload-list="false"
                      :before-upload="
                        (file) => beforeQaImageUpload(file, index)
                      "
                      :customRequest="customUploadRequest"
                    >
                      <div
                        class="text-center text-gray-500 cursor-pointer hover:text-blue-500"
                      >
                        <a-icon type="plus" class="text-2xl" />
                        <div class="text-xs mt-1">上傳圖片</div>
                      </div>
                    </a-upload>
                  </div>
                </div>
              </div>

              <!-- 圖片變更提示 -->
              <div
                v-if="
                  qaNewImages.before || qaNewImages.correct || qaNewImages.wrong
                "
                class="mt-3 text-sm text-green-600"
              >
                <a-icon type="info-circle" class="mr-1" />
                已選擇新圖片，提交後將更新對應的背景圖
              </div>

              <!-- 圖片規格說明 -->
              <div class="text-sm text-gray-500 bg-gray-100 p-3 rounded mt-3">
                <a-icon type="info-circle" class="mr-1" />
                問答背景圖片規格：
                <ul class="mt-1 ml-4 list-disc">
                  <li>檔案大小：不超過 4MB</li>
                  <li>檔案格式：JPG、PNG、GIF</li>
                  <li>建議尺寸：1024x1280 像素</li>
                </ul>
              </div>
            </div>
          </div>
        </a-form>
      </a-modal>

      <!-- 🆕 圖片預覽模態窗 -->
      <a-modal
        :visible="previewVisible"
        :footer="null"
        @cancel="previewVisible = false"
        :width="800"
      >
        <img alt="圖片預覽" style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import draggable from 'vuedraggable'
export default {
  name: 'AdCampaignList',
  components: { draggable },
  data () {
    return {
      moment,
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      // 搜索條件
      searchForm: {
        search: '',
        slot_id: undefined,
        group_id: undefined,
        ad_type: undefined,
        is_active: undefined,
        period_from: undefined,
        period_to: undefined
      },
      dateRange: [],

      // 表格數據
      loading: false,
      campaignList: [],

      // 分頁
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true
      },

      // 排序
      sorter: {
        field: 'start_date',
        order: 'desc'
      },

      // 下拉選項
      slotOptions: [],
      groupOptions: [],

      // 表格列定義
      columns: [
        // {
        //   title: '檔期ID',
        //   dataIndex: 'campaign_id',
        //   key: 'campaign_id',
        //   width: 100,
        //   sorter: true
        // },
        {
          title: '檔期名稱',
          dataIndex: 'campaign_name',
          key: 'campaign_name',
          width: 150,
          sorter: true
        },
        {
          title: '廣告版位',
          dataIndex: 'slot_name',
          key: 'slot_name',
          width: 80,
          sorter: true
        },
        {
          title: '機台群組',
          dataIndex: 'group_name',
          key: 'group_name',
          width: 120,
          sorter: true
        },
        {
          title: '機台數量',
          dataIndex: 'machine_count',
          key: 'machine_count',
          width: 70,
          scopedSlots: { customRender: 'machineCount' }
        },
        {
          title: '優先級',
          dataIndex: 'priority',
          key: 'priority',
          width: 70,
          sorter: true,
          customRender: (val) => {
            const colors = ['', 'red', 'orange', 'blue', 'green', 'purple']
            return <a-tag color={colors[val]}>{val}</a-tag>
          }
        },
        {
          title: '廣告類型',
          dataIndex: 'ad_type',
          key: 'ad_type',
          width: 50,
          scopedSlots: { customRender: 'adType' },
          sorter: true
        },
        {
          title: '開始日期',
          dataIndex: 'start_datetime',
          key: 'start_datetime',
          width: 90,
          sorter: true,
          customRender: (text) => {
            if (!text) return '-'
            // 明確指定這是 UTC 時間，然後轉換為本地時間
            return moment.utc(text).local().format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '結束日期',
          dataIndex: 'end_datetime',
          key: 'end_datetime',
          width: 90,
          sorter: true,
          customRender: (text) => {
            if (!text) return '-'
            // 明確指定這是 UTC 時間，然後轉換為本地時間
            return moment.utc(text).local().format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '顯示時段',
          key: 'timeRange',
          width: 90,
          scopedSlots: { customRender: 'timeRange' }
        },
        // {
        //   title: '顯示時長',
        //   dataIndex: 'duration_seconds',
        //   key: 'duration_seconds',
        //   width: 100,
        //   customRender: val => `${val} 秒`
        // },
        {
          title: '狀態',
          dataIndex: 'is_active',
          key: 'is_active',
          width: 80,
          scopedSlots: { customRender: 'status' },
          sorter: true
        },
        {
          title: '操作',
          key: 'action',
          // fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 編輯相關
      editModalVisible: false,
      editLoading: false,
      editForm: null,
      currentRecord: {}, // 當前正在編輯的記錄
      // 🆕 圖片編輯相關
      currentImages: [], // 當前檔期的圖片檔名列表 (可拖曳調整)
      originalImages: [], // 原始圖片順序 (用於比對是否變更)
      newImageList: [], // 新上傳的圖片列表
      previewVisible: false,
      previewImage: '',
      // 新增刪除狀態記錄
      deletingIds: [],
      // 🆕 問答廣告編輯相關
      questionBank: [], // 問答題庫列表
      currentQuestionData: null, // 當前問答廣告的完整資料 (含 question_id, question_images)
      qaCurrentImages: [], // 問答廣告當前三張圖片檔名 [未作答, 正確, 錯誤]
      qaNewImages: {
        // 問答廣告新上傳的圖片 (單獨替換)
        before: null, // index 0: 未作答
        correct: null, // index 1: 正確
        wrong: null // index 2: 錯誤
      },
      qaImageLabels: ['未作答背景圖', '答對背景圖', '答錯背景圖'], // UI 顯示標籤
      selectedQuestionId: null // 編輯時選擇的問答題目 ID
    }
  },
  // 🆕 計算屬性：判斷圖片順序是否變更
  computed: {
    isImageOrderChanged () {
      if (this.originalImages.length === 0) return false
      if (this.currentImages.length !== this.originalImages.length) { return false }
      return this.currentImages.some(
        (img, index) => img !== this.originalImages[index]
      )
    },
    // 🆕 計算屬性：當前選擇的問答題目詳情
    selectedQuestion () {
      if (!this.selectedQuestionId || !this.questionBank.length) return null
      return this.questionBank.find((q) => q.id === this.selectedQuestionId)
    },
    // 🆕 計算屬性：問答廣告是否有任何變更
    hasQaChanges () {
      // 題目變更
      const questionChanged =
        this.currentQuestionData &&
        this.selectedQuestionId !== this.currentQuestionData.question_id
      // 圖片變更 (任一張有新上傳)
      const imagesChanged =
        this.qaNewImages.before ||
        this.qaNewImages.correct ||
        this.qaNewImages.wrong
      return questionChanged || imagesChanged
    }
  },
  created () {
    this.fetchCampaignList()
    this.fetchSlotOptions()
    this.fetchGroupOptions()
    this.fetchQuestionBank() // 🆕 載入問答題庫
  },
  methods: {
    // 🆕 **輔助方法2：直接使用已載入的群組數據**
    fetchGroupDeviceMacs (groupId) {
      try {
        console.log('🔍 從已載入的群組數據中查找設備, groupId:', groupId)

        // 🔍 從已載入的群組選項中找到指定群組
        const targetGroup = this.groupOptions.find(
          (group) => group.id === groupId
        )

        if (!targetGroup) {
          console.warn('⚠️ 找不到指定的群組:', groupId)
          return Promise.resolve([])
        }

        // 🖥️ 提取群組內的所有設備 MAC 地址
        const devices = targetGroup.stores_data || []
        const deviceMacs = devices
          .filter((device) => device.device_mac)
          .map((device) => device.device_mac)

        console.log('📱 成功獲取設備 MAC 清單:', deviceMacs)
        console.log('📊 群組資訊:', {
          groupName: targetGroup.name,
          totalDevices: devices.length,
          activeDevices: deviceMacs.length
        })

        return Promise.resolve(deviceMacs)
      } catch (error) {
        console.error('❌ 獲取群組設備錯誤:', error)
        return Promise.resolve([])
      }
    },
    // 🆕 **輔助方法1：檢查排程是否正在進行中**
    checkIfScheduleActive (record) {
      const now = moment()

      // 🕐 將 UTC 時間轉換為本地時間進行比較
      const startDateTime = moment.utc(record.start_datetime).local()
      const endDateTime = moment.utc(record.end_datetime).local()
      console.log('now', now)
      console.log('startDateTime', startDateTime)
      console.log('endDateTime', endDateTime)
      // 📅 檢查是否在日期範圍內
      const isInDateRange = now.isBetween(
        startDateTime,
        endDateTime,
        null,
        '[]'
      ) // [] 表示包含邊界
      console.log('isInDateRange', isInDateRange)

      if (!isInDateRange) {
        console.log('⏰ 當前時間不在排程日期範圍內')
        console.log('  - 當前時間:', now.format('YYYY-MM-DD HH:mm:ss'))
        console.log(
          '  - 排程開始:',
          startDateTime.format('YYYY-MM-DD HH:mm:ss')
        )
        console.log('  - 排程結束:', endDateTime.format('YYYY-MM-DD HH:mm:ss'))
        return false
      }

      // 🕒 檢查是否在每日時間範圍內
      const currentTime = now.format('HH:mm:ss')
      const startTime = record.start_time
      const endTime = record.end_time

      // 處理跨午夜的情況
      let isInTimeRange
      if (endTime < startTime) {
        // 跨午夜：例如 22:00:00 - 06:00:00
        isInTimeRange = currentTime >= startTime || currentTime <= endTime
      } else {
        // 同一天：例如 09:00:00 - 18:00:00
        isInTimeRange = currentTime >= startTime && currentTime <= endTime
      }

      if (!isInTimeRange) {
        console.log('⏰ 當前時間不在每日播放時間範圍內')
        console.log('  - 當前時間:', currentTime)
        console.log('  - 播放開始:', startTime)
        console.log('  - 播放結束:', endTime)
        return false
      }

      console.log('✅ 排程正在進行中')
      console.log('  - 當前時間:', now.format('YYYY-MM-DD HH:mm:ss'))
      console.log('  - 每日播放時段:', `${startTime} - ${endTime}`)
      return true
    },
    async handleDelete (record) {
      try {
        // 🕐 **步驟1：判斷當前時間是否在排程內**
        const isCurrentlyActive = this.checkIfScheduleActive(record)
        let deviceMacs = []

        if (isCurrentlyActive) {
          console.log('📅 排程目前正在進行中，需要獲取設備清單')
          // 🖥️ **步驟2：使用修正版的方法獲取設備 MAC**
          deviceMacs = await this.fetchGroupDeviceMacs(record.group_id)
          console.log('📱 獲取到的設備 MAC:', deviceMacs)
        } else {
          console.log('⏰ 排程目前未在進行中，無需通知設備')
        }
        // deviceMacs.push('000732c5d112') // 測試用

        // 🗑️ **步驟3：調用刪除 API**
        const deletePayload = {
          campaign_id: record.campaign_id,
          device_macs: deviceMacs // null 表示不在排程內，[] 表示無設備，[...] 表示有設備需要通知
        }

        console.log('🚀 準備刪除，payload:', deletePayload)

        const response = await this.axios.delete(
          `${this.baseURL}${this.basePort}/adCampaigns/delete/${record.campaign_id}`,
          {
            data: deletePayload
          }
        )

        if (response.data.message === 'success') {
          const campaignName = response.data.data.campaign_name || '廣告排程'

          let successMessage = `${campaignName} 已成功刪除`

          if (isCurrentlyActive && deviceMacs && deviceMacs.length > 0) {
            successMessage += `，已通知 ${deviceMacs.length} 台設備下架廣告`
          } else if (
            isCurrentlyActive &&
            (!deviceMacs || deviceMacs.length === 0)
          ) {
            successMessage += '，但該群組無活動設備'
          }

          if (response.data.data.ad_deleted) {
            successMessage += '，廣告內容也已一併刪除'
          }

          this.$message.success(successMessage)
          this.fetchCampaignList()
        } else {
          throw new Error(response.data.errorMsg || '刪除廣告排程失敗')
        }
      } catch (error) {
        console.error('❌ 刪除廣告排程錯誤:', error)
        let errorMessage = '刪除廣告排程失敗'

        if (error.response && error.response.data) {
          errorMessage = error.response.data.errorMsg || errorMessage
        } else if (error.message) {
          errorMessage = error.message
        }
        this.$message.error(errorMessage + '，請稍後重試')
      }
    },
    // 處理編輯按鈕點擊
    async handleEdit (record) {
      console.log('編輯記錄:', record)
      console.log(
        moment.utc(record.start_datetime).local().format('YYYY-MM-DD HH:mm:ss')
      )
      this.checkIfScheduleActive(record)
      this.currentRecord = { ...record }

      // 🆕 根據廣告類型載入對應資料
      if (record.ad_type === 'image') {
        // 圖片廣告：載入當前圖片
        await this.loadCurrentImages(record.campaign_id)
      } else if (record.ad_type === 'interactive_qa') {
        // 問答廣告：載入問答資料與圖片
        await this.loadCurrentQaData(record.campaign_id)
      }

      this.editModalVisible = true

      // 在下一個事件循環中初始化表單，確保模態窗已經渲染
      this.$nextTick(() => {
        this.editForm = this.$form.createForm(this)
      })
    },

    // 🆕 載入當前檔期圖片 (GET /adCampaigns/:campaign_id/images)
    async loadCurrentImages (campaignId) {
      try {
        const response = await this.axios.get(
          `${this.baseURL}${this.basePort}/adCampaigns/${campaignId}/images`
        )
        if (response.data.message === 'success') {
          const images = response.data.data.images || []
          this.currentImages = [...images]
          this.originalImages = [...images] // 記錄原始順序
          console.log('載入當前圖片:', this.currentImages)
        } else {
          this.currentImages = []
          this.originalImages = []
        }
      } catch (error) {
        console.error('載入圖片錯誤:', error)
        this.currentImages = []
        this.originalImages = []
      }
    },

    // 🆕 載入問答廣告資料 (與圖片廣告共用 GET /adCampaigns/:campaign_id/images)
    async loadCurrentQaData (campaignId) {
      try {
        const response = await this.axios.get(
          `${this.baseURL}${this.basePort}/adCampaigns/${campaignId}/images`
        )
        if (response.data.message === 'success') {
          const data = response.data.data
          // 問答廣告回傳格式: { question_id: xxx, images: ["before.jpg", "correct.jpg", "wrong.jpg"] }
          this.currentQuestionData = {
            question_id: data.question_id,
            question_images: data.images || []
          }
          this.selectedQuestionId = data.question_id
          this.qaCurrentImages = data.images || []
          console.log('載入問答資料:', this.currentQuestionData)
          console.log('問答圖片:', this.qaCurrentImages)
        } else {
          this.resetQaEditState()
        }
      } catch (error) {
        console.error('載入問答資料錯誤:', error)
        this.resetQaEditState()
      }
    },

    // 🆕 重置問答編輯狀態
    resetQaEditState () {
      this.currentQuestionData = null
      this.selectedQuestionId = null
      this.qaCurrentImages = []
      this.qaNewImages = { before: null, correct: null, wrong: null }
    },

    // 🆕 取得問答圖片 URL (與圖片廣告共用 GET /adCampaigns/:campaign_id/images/:filename)
    getQaImageUrl (campaignId, filename) {
      return `${this.baseURL}${this.basePort}/adCampaigns/${campaignId}/images/${filename}`
    },

    // 🆕 獲取問答題庫列表
    fetchQuestionBank () {
      this.axios
        .get(`${this.baseURL}${this.basePort}/questionBank/list`)
        .then((res) => {
          if (res.data.message === 'success') {
            this.questionBank = res.data.data
            console.log('載入問答題庫:', this.questionBank.length, '題')
          } else {
            console.warn('獲取問答題庫失敗：', res.data.message)
          }
        })
        .catch((error) => {
          console.error('獲取問答題庫出錯:', error)
        })
    },

    // 🆕 取得圖片 URL (GET /adCampaigns/:campaign_id/images/:filename)
    getImageUrl (campaignId, filename) {
      return `${this.baseURL}${this.basePort}/adCampaigns/${campaignId}/images/${filename}`
    },

    // 關閉編輯模態窗
    closeEditModal () {
      this.editModalVisible = false
      this.currentRecord = {}
      // 🆕 清理圖片廣告狀態
      this.currentImages = []
      this.originalImages = []
      this.newImageList = []
      this.previewVisible = false
      this.previewImage = ''
      // 🆕 清理問答廣告狀態
      this.resetQaEditState()
    },

    // 提交編輯表單
    handleEditSubmit () {
      this.editForm.validateFields(async (errors, values) => {
        if (errors) {
          return
        }

        // 轉換日期和時間格式
        const formattedValues = {
          ...values,
          start_datetime: values.start_datetime
            .utc()
            .format('YYYY-MM-DD HH:mm:ss'),
          end_datetime: values.end_datetime.utc().format('YYYY-MM-DD HH:mm:ss'),
          start_time: values.start_time.format('HH:mm:ss'),
          end_time: values.end_time.format('HH:mm:ss'),
          priority: parseInt(values.priority),
          display_order: parseInt(values.display_order || 1),
          duration_seconds: parseInt(values.duration_seconds || 10)
        }

        // 驗證結束日期時間不早於開始日期時間
        if (
          moment(formattedValues.end_datetime).isBefore(
            formattedValues.start_datetime
          )
        ) {
          this.$message.error('結束日期時間不能早於開始日期時間')
          return
        }

        this.editLoading = true

        try {
          // 🆕 根據廣告類型處理不同的更新邏輯
          if (this.currentRecord.ad_type === 'image') {
            // === 圖片廣告更新邏輯 ===
            const hasNewImages = this.newImageList.length > 0
            const hasOrderChanged = this.isImageOrderChanged

            if (hasNewImages) {
              // 情況 1：有新圖片 -> 完全替換 (PUT /adCampaigns/:campaign_id/images)
              await this.updateCampaignImages(this.currentRecord.campaign_id)
            } else if (hasOrderChanged) {
              // 情況 2：只調整順序 -> 帶入 image_filenames 到更新 API
              formattedValues.image_filenames = this.currentImages
            }

            // 更新排程設定 (PUT /adCampaigns/update/:id)
            const res = await this.axios.put(
              `${this.baseURL}${this.basePort}/adCampaigns/update/${this.currentRecord.campaign_id}`,
              formattedValues
            )

            if (res.data.message === 'success') {
              let successMsg = '廣告排程更新成功'
              if (hasNewImages) successMsg += '，圖片已同步更新'
              else if (hasOrderChanged) successMsg += '，圖片順序已調整'
              this.$message.success(successMsg)
              this.closeEditModal()
              this.fetchCampaignList()
            } else if (res.data.message === 'conflict') {
              const conflictMsg =
                res.data.data.conflict_message || '與其他廣告排程發生衝突'
              this.$message.error(conflictMsg)
            } else {
              this.$message.error(res.data.errorMsg || '更新廣告排程失敗')
            }
          } else if (this.currentRecord.ad_type === 'interactive_qa') {
            // === 問答廣告更新邏輯 ===
            const questionChanged =
              this.currentQuestionData &&
              this.selectedQuestionId !== this.currentQuestionData.question_id
            const hasNewQaImages =
              this.qaNewImages.before ||
              this.qaNewImages.correct ||
              this.qaNewImages.wrong

            // 🆕 題目更換：呼叫 PATCH /adCampaigns/:campaign_id
            if (questionChanged) {
              await this.updateQuestion(
                this.currentRecord.campaign_id,
                this.selectedQuestionId
              )
            }

            // 🆕 圖片更換：逐張呼叫 PUT /adCampaigns/:campaign_id/question-images/:image_type
            if (hasNewQaImages) {
              await this.updateQaImages(this.currentRecord.campaign_id)
            }

            // 更新排程設定
            const res = await this.axios.put(
              `${this.baseURL}${this.basePort}/adCampaigns/update/${this.currentRecord.campaign_id}`,
              formattedValues
            )

            if (res.data.message === 'success') {
              let successMsg = '廣告排程更新成功'
              if (questionChanged) successMsg += '，題目已更換'
              if (hasNewQaImages) successMsg += '，背景圖片已更新'
              this.$message.success(successMsg)
              this.closeEditModal()
              this.fetchCampaignList()
            } else if (res.data.message === 'conflict') {
              const conflictMsg =
                res.data.data.conflict_message || '與其他廣告排程發生衝突'
              this.$message.error(conflictMsg)
            } else {
              this.$message.error(res.data.errorMsg || '更新廣告排程失敗')
            }
          }
        } catch (err) {
          console.error('更新廣告排程錯誤:', err)
          if (err.response && err.response.data) {
            this.$message.error(
              err.response.data.errorMsg || '更新廣告排程失敗'
            )
          } else {
            this.$message.error(err.message || '更新廣告排程失敗，請稍後重試')
          }
        } finally {
          this.editLoading = false
        }
      })
    },

    // 🆕 更新檔期圖片 (PUT /adCampaigns/:campaign_id/images)
    async updateCampaignImages (campaignId) {
      const formData = new FormData()
      this.newImageList.forEach((file) => {
        const actualFile = file.originFileObj || file
        formData.append('images', actualFile)
      })

      const response = await this.axios.put(
        `${this.baseURL}${this.basePort}/adCampaigns/${campaignId}/images`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )

      if (response.data.message !== 'success') {
        throw new Error(response.data.errorMsg || '圖片更新失敗')
      }

      console.log('圖片更新成功:', response.data.data)
      return response.data.data
    },

    // 🆕 更新問答題目 (PATCH /adCampaigns/:campaign_id)
    async updateQuestion (campaignId, questionId) {
      const response = await this.axios.patch(
        `${this.baseURL}${this.basePort}/adCampaigns/${campaignId}`,
        { question_id: questionId }
      )

      if (response.data.message !== 'success') {
        throw new Error(response.data.errorMsg || '題目更換失敗')
      }

      console.log('題目更換成功:', response.data.data)
      return response.data.data
    },

    // 🆕 更新問答廣告圖片 (PUT /adCampaigns/:campaign_id/question-images/:image_type)
    // 改為逐張圖片分別呼叫 API
    async updateQaImages (campaignId) {
      const imageTypeMap = {
        before: 'background_before',
        correct: 'background_correct',
        wrong: 'background_wrong'
      }

      const updatePromises = []

      // 逐一檢查哪些圖片有變更，建立 API 呼叫
      for (const [key, imageType] of Object.entries(imageTypeMap)) {
        if (this.qaNewImages[key]) {
          const file =
            this.qaNewImages[key].originFileObj || this.qaNewImages[key]
          const formData = new FormData()
          formData.append('images', file)

          // PUT /adCampaigns/:campaign_id/question-images/:image_type
          const promise = this.axios
            .put(
              `${this.baseURL}${this.basePort}/adCampaigns/${campaignId}/question-images/${imageType}`,
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            )
            .then((response) => {
              if (response.data.message !== 'success') {
                throw new Error(
                  response.data.errorMsg || `${imageType} 圖片更新失敗`
                )
              }
              console.log(`${imageType} 圖片更新成功:`, response.data.data)
              return response.data.data
            })

          updatePromises.push(promise)
        }
      }

      // 等待所有圖片更新完成
      if (updatePromises.length > 0) {
        await Promise.all(updatePromises)
        console.log(`問答圖片更新完成，共更新 ${updatePromises.length} 張`)
      }
    },

    // 🆕 問答圖片上傳前檢查
    beforeQaImageUpload (file, index) {
      // 檢查檔名是否包含空格
      if (file.name.includes(' ')) {
        this.$message.error('檔案名稱不能包含空格，請重新命名後再上傳')
        return false
      }

      // 檢查檔案類型
      const fileType = file.type
      const isJpg = fileType === 'image/jpeg' || fileType === 'image/jpg'
      const isPng = fileType === 'image/png'
      const isGif = fileType === 'image/gif'

      if (!isJpg && !isPng && !isGif) {
        this.$message.error('只能上傳 JPG、PNG、GIF 格式的圖片！')
        return false
      }

      // 檢查檔案大小 (4MB 上限)
      const isLt4M = file.size / 1024 / 1024 < 4
      if (!isLt4M) {
        this.$message.error('圖片大小不能超過 4MB！')
        return false
      }

      // 建立預覽並儲存
      const url = URL.createObjectURL(file)
      const key = this.getQaImageKey(index)
      this.qaNewImages[key] = {
        originFileObj: file,
        url: url,
        name: file.name
      }

      return false // 阻止自動上傳
    },

    // 🆕 移除問答新圖片
    removeQaNewImage (index) {
      const key = this.getQaImageKey(index)
      if (this.qaNewImages[key] && this.qaNewImages[key].url) {
        URL.revokeObjectURL(this.qaNewImages[key].url)
      }
      this.qaNewImages[key] = null
    },

    // 🆕 取得問答圖片 key (index -> before/correct/wrong)
    getQaImageKey (index) {
      const keys = ['before', 'correct', 'wrong']
      return keys[index]
    },

    // 🆕 圖片上傳前檢查 (與新增排程保持一致)
    beforeImageUpload (file) {
      // 檢查檔名是否包含空格
      if (file.name.includes(' ')) {
        this.$message.error('檔案名稱不能包含空格，請重新命名後再上傳')
        return false
      }

      // 檢查當前上傳數量
      if (this.newImageList.length >= 10) {
        this.$message.error('最多只能上傳10張圖片')
        return false
      }

      // 檢查檔案類型 (與 AdSchedule.vue 保持一致)
      const fileType = file.type
      const isImage = fileType.startsWith('image/')
      const isJpg = fileType === 'image/jpeg' || fileType === 'image/jpg'
      const isPng = fileType === 'image/png'
      const isGif = fileType === 'image/gif'

      if (!isImage) {
        this.$message.error('請上傳圖片檔案！')
        return false
      }

      if (!isJpg && !isPng && !isGif) {
        this.$message.error('只能上傳 JPG、PNG、GIF 格式的圖片！')
        return false
      }

      // 檢查檔案大小 (4MB 上限)
      const isLt4M = file.size / 1024 / 1024 < 4
      if (!isLt4M) {
        this.$message.error('圖片大小不能超過 4MB！')
        return false
      }

      // 檢查圖片尺寸 (與新增排程保持一致的邏輯)
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          const isValidSize = img.width >= 100 && img.height >= 100
          if (!isValidSize) {
            this.$message.warning('圖片尺寸建議至少 100x100 像素，但仍可使用')
          }
          resolve(true)
        }
        img.onerror = () => {
          this.$message.error('圖片載入失敗，請確認檔案格式正確')
          resolve(false)
        }
        img.src = URL.createObjectURL(file)
      })
    },

    // 🆕 自定義上傳請求 (不實際上傳，僅暂存檔案)
    customUploadRequest ({ file, onSuccess }) {
      setTimeout(() => onSuccess(null, file), 100)
    },

    // 🆕 處理新圖片變更
    handleNewImageChange ({ file, fileList }) {
      if (file.status === 'removed') {
        this.newImageList = fileList
      } else if (file.status === 'done' || file.status === 'uploading') {
        this.newImageList = fileList.map((f) => {
          if (f.originFileObj && !f.url) {
            f.url = URL.createObjectURL(f.originFileObj)
          }
          return f
        })
      }
    },

    // 🆕 移除新圖片
    removeNewImage (file) {
      this.newImageList = this.newImageList.filter((f) => f.uid !== file.uid)
    },

    // 🆕 圖片預覽
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },

    // 🆕 顯示圖片預覽 (URL 版本)
    showImagePreview (imageUrl) {
      this.previewImage = imageUrl
      this.previewVisible = true
    },

    // 🆕 圖片載入錯誤處理
    handleImageError (event) {
      console.error('圖片載入失敗:', event.target.src)
      event.target.style.display = 'none'
    },
    // 獲取廣告排程列表
    fetchCampaignList () {
      this.loading = true

      // 準備查詢參數
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sort: this.sorter.field,
        order: this.sorter.order,
        ...this.searchForm
      }

      // 發送請求
      this.axios
        .get(`${this.baseURL}${this.basePort}/adCampaigns/list`, { params })
        .then((res) => {
          if (res.data.message === 'success') {
            // this.campaignList = res.data.data
            // 只保留表格需要的欄位
            // this.campaignList = res.data.data.map(item => {
            //   return {
            //     campaign_id: item.campaign_id,
            //     campaign_name: item.campaign_name,
            //     slot_name: item.slot_name,
            //     group_name: item.group_name,
            //     machine_count: item.machine_count,
            //     ad_type: item.ad_type,
            //     start_date: item.start_date,
            //     end_date: item.end_date,
            //     start_time: item.start_time,
            //     end_time: item.end_time,
            //     is_active: item.is_active
            //   }
            // })
            this.campaignList = res.data.data.map((item) => {
              return {
                campaign_id: item.campaign_id,
                campaign_name: item.campaign_name,
                slot_id: item.slot_id,
                slot_name: item.slot_name,
                group_id: item.group_id,
                group_name: item.group_name,
                machine_count: item.machine_count,
                ad_type: item.ad_type,
                // 使用完整的日期時間字段
                start_datetime: item.start_datetime,
                end_datetime: item.end_datetime,
                start_time: item.start_time,
                end_time: item.end_time,
                // 新增字段
                priority: item.priority,
                display_order: item.display_order,
                duration_seconds: item.duration_seconds,
                is_active: item.is_active
              }
            })
            console.log('獲取廣告排程列表成功:', this.campaignList)
            // 更新分頁信息
            if (res.data.pagination) {
              this.pagination.total = res.data.pagination.totalItems
              this.pagination.current = res.data.pagination.currentPage
              this.pagination.pageSize = res.data.pagination.pageSize
            }
          } else {
            this.$message.error(res.data.errorMsg || '獲取廣告排程列表失敗')
          }
        })
        .catch((err) => {
          console.error('獲取廣告排程列表錯誤:', err)
          this.$message.error('獲取廣告排程列表失敗，請稍後重試')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 獲取廣告版位選項
    fetchSlotOptions () {
      this.axios
        .get(`${this.baseURL}${this.basePort}/adCampaigns/slots`)
        .then((res) => {
          if (res.data.message === 'success') {
            this.slotOptions = res.data.data
          } else {
            this.$message.error('獲取廣告版位失敗：' + res.data.message)
          }
        })
        .catch((error) => {
          console.error('獲取廣告版位出錯:', error)
          this.$message.error('獲取廣告版位失敗，請稍後重試')
        })
    },

    // 獲取機台群組選項
    fetchGroupOptions () {
      this.axios
        .get(`${this.baseURL}${this.basePort}/ads/groups`)
        .then((res) => {
          if (res.data.message === 'success') {
            this.groupOptions = res.data.data
          } else {
            this.$message.error('獲取機台群組失敗：' + res.data.message)
          }
        })
        .catch((error) => {
          console.error('獲取機台群組出錯:', error)
          this.$message.error('獲取機台群組失敗，請稍後重試')
        })
        .finally(() => {
          this.loadingGroups = false
        })
    },

    // 處理搜索
    handleSearch () {
      this.pagination.current = 1 // 重置到第一頁
      this.fetchCampaignList()
    },

    // 重置搜索條件
    resetSearch () {
      this.searchForm = {
        search: '',
        slot_id: undefined,
        group_id: undefined,
        ad_type: undefined,
        is_active: undefined,
        period_from: undefined,
        period_to: undefined
      }
      this.dateRange = []
      this.pagination.current = 1
      this.fetchCampaignList()
    },

    // 處理日期範圍變更
    onDateChange (dates, dateStrings) {
      if (dates && dates.length === 2) {
        // 現在 dateStrings 包含完整的日期時間格式，例如："2023-08-25 14:30:00"
        this.searchForm.period_from = dateStrings[0]
        this.searchForm.period_to = dateStrings[1]
      } else {
        this.searchForm.period_from = undefined
        this.searchForm.period_to = undefined
      }
    },

    // 處理表格變更 (排序)
    handleTableChange (pagination, filters, sorter) {
      if (sorter && sorter.columnKey) {
        this.sorter.field = sorter.columnKey
        this.sorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      } else {
        this.sorter.field = 'start_date'
        this.sorter.order = 'desc'
      }
      this.fetchCampaignList()
    },

    // 處理頁碼變更
    handlePageChange (page) {
      this.pagination.current = page
      this.fetchCampaignList()
    },

    // 處理每頁顯示數量變更
    handleSizeChange (current, size) {
      this.pagination.current = 1
      this.pagination.pageSize = size
      this.fetchCampaignList()
    },
    // 處理刪除
    handleDelete1 (record) {
      this.axios
        .delete(
          `${this.baseURL}${this.basePort}/adCampaigns/delete/${record.campaign_id}`
        )
        .then((res) => {
          if (res.data.message === 'success') {
            // 獲取刪除的廣告名稱用於提示
            const campaignName = res.data.data.campaign_name || '廣告排程'

            // 根據是否同時刪除了廣告內容顯示不同提示
            if (res.data.data.ad_deleted) {
              this.$message.success(`${campaignName} 及其廣告內容已成功刪除`)
            } else {
              this.$message.success(`${campaignName} 已成功刪除`)
            }

            // 重新獲取列表
            this.fetchCampaignList()
          } else {
            this.$message.error(res.data.errorMsg || '刪除廣告排程失敗')
          }
        })
        .catch((err) => {
          console.error('刪除廣告排程錯誤:', err)

          // 處理特定錯誤情況
          if (err.response && err.response.data) {
            this.$message.error(
              err.response.data.errorMsg || '刪除廣告排程失敗'
            )
          } else {
            this.$message.error('刪除廣告排程失敗，請稍後重試')
          }
        })
        .finally(() => {
          // 從正在刪除列表中移除
          this.deletingIds = this.deletingIds.filter(
            (id) => id !== record.campaignId
          )
        })
    },

    // 禁用過去的日期
    disabledDate (current) {
      return current && current < moment().startOf('day')
    }
  }
}
</script>

<style lang="css" scoped>
/* 自定義樣式 */
:deep(.ant-table-thead > tr > th) {
  background-color: #f0f5ff;
  font-weight: 600;
  white-space: nowrap;
}

.ant-form-item {
  margin-bottom: 12px;
}

/* 模態窗樣式 */
:deep(.ant-form-item-label) {
  font-weight: 500;
}

:deep(.ant-modal-body) {
  padding: 24px 24px 16px;
}

.edit-form-tip {
  margin-top: 16px;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
  font-size: 14px;
}

:deep(.ant-popover-message-title) {
  max-width: 250px;
}

:deep(.ant-popover-buttons) {
  text-align: right;
}

/* 🆕 編輯模態窗上傳元件樣式 */
:deep(.edit-uploader .ant-upload.ant-upload-select-picture-card) {
  width: 104px;
  height: 104px;
  margin: 0;
}

:deep(.edit-uploader .ant-upload-text) {
  font-size: 12px;
  margin-top: 8px;
}
</style>
